<template src="../templates/normal_fcont_207.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import PrintButton from '../components/PrintButton'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadColorioNenga from '../components/AppDownloadColorioNenga'
import AppDownloadPhotoPlusJp from '../components/AppDownloadPhotoPlusJp'
import { Carousel,Slide } from 'uiv'


export default {
  name: 'app',
  data() {
    return {
      articleId: '207',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,PrintButton,
    ReleaseDateForArticle,AppDownloadColorioNenga,AppDownloadPhotoPlusJp
  },
  computed: {
    fcontId: function () {
      return this.$route.path.match(/\/\d+/).shift().slice(1);
    },
  },
  
  mounted() {
    const self = this; // function内でVueインスタンスを参照するためthisを保持

    // 年賀チームよりもらったjavaScriptコードをこちらに転記し、以下を変更した。
    // 1. documentで参照されている部分をself.$elに変更。影響範囲をこの記事内に留めるため。
    // ただし、body要素を操作する場合は、documentでないと操作できないためそのままとする。
    // 2. document.getElementById('xxx')はdocument要素のメソッドのため、self.$el.querySelector('#xxx');に変更
    
    // スライダー用スクリプト
    var sliders = self.$el.querySelectorAll('.designer-slider');
    if (!sliders.length) return;

    sliders.forEach(function (slider) {
      var viewport = slider.querySelector('.designer-viewport');
      var prevBtn  = slider.querySelector('.ds-prev');
      var nextBtn  = slider.querySelector('.ds-next');
      if (!viewport) return;

      function getScrollAmount() {
        return viewport.clientWidth * 0.95;
      }
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          viewport.scrollLeft -= getScrollAmount();
          viewport.focus();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          viewport.scrollLeft += getScrollAmount();
          viewport.focus();
        });
      }

      // キーボード操作（左右矢印）
      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          viewport.scrollLeft -= getScrollAmount();
          e.preventDefault();
        } else if (e.key === 'ArrowRight') {
          viewport.scrollLeft += getScrollAmount();
          e.preventDefault();
        }
      });
    });

    // スライダードラッグスクリプト
    var viewports = self.$el.querySelectorAll('.designer-viewport');
    if (!viewports.length) return;

    viewports.forEach(function (viewport) {
      var isDown = false, startX = 0, startLeft = 0;

      viewport.addEventListener('mousedown', function (e) {
        isDown = true;
        startX = e.pageX;
        startLeft = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
      });

      self.$el.addEventListener('mouseup', function () {
        isDown = false;
        viewport.classList.remove('is-dragging');
      });

      self.$el.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        viewport.scrollLeft = startLeft - (e.pageX - startX);
      });

      // タッチ対応（お好みで）
      viewport.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        isDown = true;
        startX = t.pageX;
        startLeft = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
      }, {passive:true});

      viewport.addEventListener('touchend', function () {
        isDown = false;
        viewport.classList.remove('is-dragging');
      });

      viewport.addEventListener('touchmove', function (e) {
        if (!isDown) return;
        var t = e.touches[0];
        viewport.scrollLeft = startLeft - (t.pageX - startX);
      }, {passive:true});
    });

    // モーダルスクリプト
    // var modal   = document.getElementById('designerModal');
    var modal = self.$el.querySelector('#designerModal');
    if (!modal) return;

    var content = modal.querySelector('.ds-modal__content');
    var imgEl   = modal.querySelector('.ds-modal__img');
    var nameEl  = modal.querySelector('.ds-modal__name');
    var descEl  = modal.querySelector('.ds-modal__desc');

    function openModalFromCard(card) {
      var img  = card.querySelector('img');
      var name = card.querySelector('.designer-name');
      var desc = card.querySelector('.designer-desc');

      imgEl.src = img ? img.getAttribute('src') : '';
      imgEl.alt = (img && img.getAttribute('alt')) || (name ? name.textContent.trim() : '');
      nameEl.textContent = name ? name.textContent.trim() : '';
      descEl.textContent = desc ? desc.textContent.trim() : '';

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ds-no-scroll');
      content.focus();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ds-no-scroll');
    }

    // クリックを document に委譲：全ての .designer-card が対象
    self.$el.addEventListener('click', function (e) {
      var card = e.target.closest('.designer-card');
      if (card) {
        openModalFromCard(card);
        return;
      }
      // 背景 or コンテンツクリックで閉じる
      if (e.target.closest('.ds-modal__backdrop') || e.target.closest('.ds-modal__content')) {
        if (modal.classList.contains('is-open')) closeModal();
      }
    });

    // Escで閉じる
    self.$el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    imgEl.draggable = false;
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['207-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['207-3']}
      ]
    };
  }

};


</script>

<style scoped>
ul.point {
    list-style: none;
    padding: 0;
}

li.margin {
    margin-top: 15px;
}

/* 年賀チームよりもらったcssコードをこちらに転記した。 */
/* 1つbodyに対するcssの設定（body.ds-no-scroll）があり、このvueファイルからは操作できないため、App.vueに追記している。 */

/* スライダー用CSS ここから↓ */
/* スライダー骨格 */
.designer-slider {
    position: relative;
    margin: 10px 0 20px;
}

.designer-viewport {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    outline: none;
    padding-bottom: 8px;
    /* スクロールバー余白 */
}

.designer-track {
    display: flex;
    flex-direction: row;
    list-style: none;
    padding: 0;
    margin: 0;
}

.designer-slide {
    scroll-snap-align: center;
    flex: 0 0 auto;
    padding: 6px;
    width: 80%;
    /* モバイル：1画面に1枚見やすく */
    max-width: 520px;
    /* 画像が粗くならない程度の上限 */
}

@media (min-width: 992px) {

    /* PC：3枚並ぶくらいの幅に */
    .designer-slide {
        width: 33.3333%;
        max-width: none;
    }
}

/* カード */
.designer-card.thumbnail {
    margin: 0;
    border-radius: 8px;
    cursor: pointer;
    height: 100%;
}

.designer-card img {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}

.designer-card .caption {
    min-height: 96px;
    /* テキスト差で高さが揺れにくいように */
}

.designer-name {
    margin-top: 6px;
    margin-bottom: 6px;
    font-size: 16px;
    font-weight: 600;
}

.designer-desc {
    margin-bottom: 0;
    line-height: 1.6;
}
/* スライダー用CSS ここまで↑ */

/* 拡大モーダル ここから↓ */
/* ===== Designer Modal ===== */
  .ds-modal {
    position: fixed;
    inset: 0;
    display: none;                   /* is-openで表示 */
    align-items: center;
    justify-content: center;
    z-index: 1060;                   /* 既存より前面に */
  }
  .ds-modal.is-open { display: flex; }
  .ds-modal__backdrop {
    position: absolute;
    inset: 0;
    background: rgba(0,0,0,0.6);
    -webkit-backdrop-filter: blur(1px);
            backdrop-filter: blur(1px);
  }
  .ds-modal__content {
    position: relative;
    z-index: 1;
    background: #fff;
    border-radius: 10px;
    max-width: 900px;
    width: calc(100vw - 32px);
    max-height: calc(100vh - 32px);
    overflow: auto;
    box-shadow: 0 10px 30px rgba(0,0,0,.35);
    animation: ds-zoom-in .18s ease-out;
  }
  @keyframes ds-zoom-in {
    from { transform: scale(.92); opacity: 0; }
    to   { transform: scale(1);   opacity: 1; }
  }
  .ds-modal__img {
    display: block;
    width: 100%;
    height: auto;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .ds-modal__caption {
    padding: 14px 16px 16px;
  }
  .ds-modal__name {
    margin: 0 0 6px;
    font-size: 18px;
    font-weight: 700;
  }
  .ds-modal__desc {
    margin: 0;
    line-height: 1.7;
    color: #333;
  }
  /* 拡大モーダル ここまで↑ */
  
</style>

